/**
 * Maps GET /profiles/form-data → parent_attributes to preference tab UI state.
 */
export function applyParentAttributesToPreferenceForm(attrs, refs) {
  if (!attrs || Array.isArray(attrs) || !attrs.map) {
    return false;
  }

  const { selections, options, bussinessPartner } = refs;

  options.value = [];
  Object.keys(selections.value).forEach((key) => {
    selections.value[key] = false;
  });

  bussinessPartner.value = attrs.nonCommSel || "noBusinessRelationship";

  for (const element in attrs.map) {
    if (attrs.map[element]?.enabled) {
      options.value.push(element);
      selections.value[element] = true;
    }
  }

  return true;
}
